import navToggle from "../actions/navToggle";
import subMenuToggle from "../actions/subMenuToggle";
import renderSiteSearch from "../actions/renderSiteSearch";
/**
 * header.js
 *
 * Functionality related to the site header
 *
 *
 * @param $ jQuery
 */
const Header = ($) => {
	navToggle($);
	subMenuToggle($);
	renderSiteSearch($);
};

export default Header;
